export class HostError extends Error {
  name = 'HostError';
  constructor(message: string) {
    super(`Host initialization failed: ${message}`);
  }
}

export class ProvisionCollisionHostError extends HostError {
  name = 'ProvisionCollisionHostError';
  constructor(key: string, existing: unknown, collider: unknown) {
    super(
      `collision on provided key "${key}" (${collider} tried to replace ${existing})`,
    );
  }
}

export class AlreadyHasAppHostError extends HostError {
  name = 'AlreadyHasAppHostError';
  constructor(prev: unknown, app: unknown) {
    super(
      `tried to add a vue app (${app}) but one has already been added (${prev})`,
    );
  }
}

export class AlreadyStartedHostError extends HostError {
  name = 'AlreadyStartedHostError';
  constructor() {
    super('the host definition cannot be altered after calling start');
  }
}

// at some point, rather than passing in a whole goblin schema list, services
// can be added one at a time (and sent to the worker as well)
// currently, they're not even added dynamically.
/*
export class GoblinAfterConnectHostError extends HostError {
  name = 'GoblinAfterConnectHostError';
  constructor() {
    super('services cannot be after goblin client has connected (yet)');
  }
}
*/

export class IllegalInitHookHostError extends HostError {
  name = 'IllegalInitHookHostError';
  constructor() {
    super('init hooks may never be asynchronous, use a later hook');
  }
}

export class IllegalMetaProvisionHostError extends HostError {
  name = 'IllegalMetaProvisionHostError';
  constructor(key: string, value: unknown, shouldBe: string) {
    super(`illegal value for "${key}": ${value} (${shouldBe})`);
  }
}

export class IllegalCleanupProvisionHostError extends IllegalMetaProvisionHostError {
  name = 'IllegalCleanupProvisionHostError';
  constructor(value: unknown) {
    super(
      'cleanup',
      value,
      'a function that runs if host.start encounters an exception',
    );
  }
}

export class IllegalAppHookHostError extends HostError {
  name = 'IllegalAppHookHostError';
  constructor() {
    super('this is not a component-based app (no call to .withVue)');
  }
}

export class IllegalGoblinHookHostError extends HostError {
  name = 'IllegalGoblinHookHostError';
  constructor() {
    super(`this is not a threadgoblin-based app (no call to withGoblin)
      (if this feature doesnt need thread goblin, you can use a later hook instead)
    `);
  }
}
